import CampaignPage from "../../modules/campaign/CampaignPage";

export default function Campaigns() {
  return <CampaignPage role="user" />;
}